import React from 'react';
import { styled } from '@mui/material';
import PropTypes from 'prop-types';
import { EVENT_TAGS } from '../../../constants/eventTags';
import EventTags from './EventTags';

const StyleEventTags = styled('div', () => ({
    shouldForwardProp: (prop) => prop !== 'sx',
}))((props) => ({
    display: 'flex',
    marginLeft: 'auto',
    ...props.sx,
}));
const EventFlags = (props) => {
    const {
        isRecentSale,
        isAgentAdvice,
        isForSaleCampaign,
        isForRentCampaign,
        isHistoric,
        icon,
        sx,
    } = props;

    const hasTags = isRecentSale ||
        isAgentAdvice ||
        isForSaleCampaign ||
        isForRentCampaign ||
        isHistoric;
    if (!hasTags) {
        return null;
    }

    return (
        <StyleEventTags sx={sx}>
            {
                EVENT_TAGS.map((eventTags) => (
                    props[eventTags.flag] &&
                    <EventTags
                        key={eventTags.label}
                        label={icon ? '' : eventTags.label}
                        color={eventTags.color}
                        tooltipText={eventTags.tooltipText}
                    />
                ))
            }
        </StyleEventTags>
    );
};

EventFlags.propTypes = {
    isRecentSale: PropTypes.bool,
    isAgentAdvice: PropTypes.bool,
    isForSaleCampaign: PropTypes.bool,
    isForRentCampaign: PropTypes.bool,
    isHistoric: PropTypes.bool,
    noText: PropTypes.bool,
    sx: PropTypes.object,
};

export default EventFlags;
